import { Add, Remove } from "@mui/icons-material";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import {
  addRecipe,
  checkIfDuplicateExists,
} from "../../firebase/fireStoreServices";
import BulkUploadData from "./BulkUploadData";

export default function RecipeAdminForm() {
  const [recipeData, setRecipeData] = useState({
    title: "",
    category: "",
    description: "",
    image: "",
    videoURL: "",
    ingredients: [""],
    steps: [""],
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const isDuplicate = await checkIfDuplicateExists("recipes", {
        title: recipeData.title,
        category: recipeData.category,
        image: recipeData.image,
      });

      if (isDuplicate) {
        alert("This recipe is already present in the database!");
        return;
      } else {
        await addRecipe(recipeData); // Call your Firebase service
        alert("Recipe added successfully!");
        // Reset the form
        setRecipeData({
          title: "",
          category: "",
          description: "",
          image: "",
          videoURL: "",
          ingredients: [""],
          steps: [""],
        });
      }
    } catch (error) {
      console.error("Error adding recipe: ", error);
      alert("Failed to add recipe!");
    }
  };

  const handleChange = (event) => {
    setRecipeData({ ...recipeData, [event.target.name]: event.target.value });
  };

  const handleArrayChange = (field, index, value) => {
    const updatedArray = [...recipeData[field]];
    updatedArray[index] = value;
    setRecipeData({ ...recipeData, [field]: updatedArray });
  };

  const addArrayField = (field) => {
    setRecipeData({ ...recipeData, [field]: [...recipeData[field], ""] });
  };

  const removeArrayField = (field, index) => {
    const updatedArray = recipeData[field].filter((_, i) => i !== index);
    setRecipeData({ ...recipeData, [field]: updatedArray });
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{ mt: 5, p: 4, bgcolor: "#f9f9f9", borderRadius: 3, boxShadow: 3 }}
      >
        <Typography variant="h5" mb={3} fontWeight="bold" textAlign="center">
          Recipe Admin Form
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Title"
                name="title"
                fullWidth
                value={recipeData.title}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Category"
                name="category"
                fullWidth
                value={recipeData.category}
                onChange={handleChange}
                required
              />
            </Grid>{" "}
            <Grid item xs={12}>
              <TextField
                label="Description"
                name="description"
                fullWidth
                multiline
                rows={3}
                value={recipeData.description}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Image URL"
                name="image"
                fullWidth
                value={recipeData.image}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Video URL"
                name="videoURL"
                fullWidth
                value={recipeData.videoURL}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6">Ingredients</Typography>
              {recipeData.ingredients.map((ingredient, index) => (
                <Grid container spacing={1} alignItems="center" key={index}>
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      label={`Ingredient ${index + 1}`}
                      value={ingredient}
                      onChange={(e) =>
                        handleArrayChange("ingredients", index, e.target.value)
                      }
                      required
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <IconButton
                      color="error"
                      onClick={() => removeArrayField("ingredients", index)}
                      disabled={recipeData.ingredients.length === 1}
                    >
                      <Remove />
                    </IconButton>
                    {index === recipeData.ingredients.length - 1 && (
                      <IconButton
                        onClick={() => addArrayField("ingredients")}
                        color="success"
                      >
                        <Add />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6">Steps</Typography>
              {recipeData.steps.map((step, index) => (
                <Grid container spacing={1} alignItems="center" key={index}>
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      label={`Step ${index + 1}`}
                      value={step}
                      onChange={(e) =>
                        handleArrayChange("steps", index, e.target.value)
                      }
                      required
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <IconButton
                      color="error"
                      onClick={() => removeArrayField("steps", index)}
                      disabled={recipeData.steps.length === 1}
                    >
                      <Remove />
                    </IconButton>
                    {index === recipeData.steps.length - 1 && (
                      <IconButton
                        onClick={() => addArrayField("steps")}
                        color="success"
                      >
                        <Add />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid item xs={12} textAlign="center">
              <Button type="submit" variant="contained" color="secondary">
                Add Recipe
              </Button>
            </Grid>
          </Grid>
        </form>
        <Divider sx={{ mt: 3 }} />
        <BulkUploadData collectionName="recipes" uploadService={addRecipe} />
      </Box>
    </Container>
  );
}
